// EDIT BY ALI FOR DARK MODE - Updated imports and Card styled component
import {
  Chip,
  Grid,
} from "@mui/material";
import styled from "@emotion/styled";
export const Card = styled(Grid)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? "#FFFFFF" : "#3c3c3c",
  padding: "26px 25px",
  margin: "6px -2px",
  display: "flex",
  gap: 15,
  background: theme.palette.mode === "dark" ? "#1E1E1E" : "#FFFFFF",
  border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(88, 89, 91, 0.2)"}`,
  borderRadius: "10px",
  boxShadow: theme.palette.mode === "dark" ? "0 -1px 3px 1px rgba(0, 0, 0, 0.3)" : "0 -1px 3px 1px #D7DBDD",
  width: "100%",
  minWidth: 600,
}));
styled(Grid)(() => ({
  display: "flex",
  gap: "50px",
  mt: 2,
  alignItems: "center",
  justifyContent: "space-between",
  fontWeight: 700,
}));

// EDIT BY ALI FOR DARK MODE - Updated ChipCard to use theme colors
export const ChipCard = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#8B6A45" : "#FFF2E6",
  fontWeight: 500,
  fontSize: "16px",
  color: theme.palette.mode === "dark" ? "#FFFFFF" : "#CE6300",
  lineHeight: "20px",
  paddingLeft: "14px",
}));

// EDIT BY ALI FOR DARK MODE - Updated ChipCardSecond to use theme colors with better text visibility
export const ChipCardSecond = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.primary.main : "#FFE6FF",
  fontWeight: 500,
  fontSize: "16px",
  color: theme.palette.mode === "dark" ? "#FFFFFF" : "#9900CE",
  lineHeight: "20px",
  paddingRight: "8px",
  paddingLeft: "20px",
}));

// EDIT BY ALI FOR DARK MODE - Updated BlackDotGrid to use theme colors
export const BlackDotGrid = styled(Grid)(({ theme }) => ({
  background: theme.palette.mode === "dark" ? "#FFFFFF" : "#000000",
  width: "6px",
  height: "6px",
  borderRadius: "50%",
}));
